<div class="dtd">
  <h3 class="dtd-title">{{ data.toolLabel }}</h3>
  <textarea class="dtd-input" [(ngModel)]="text" rows="3" cdkFocusInitial
    placeholder="Escribe el texto…" (keydown.control.enter)="accept()"></textarea>
  <div class="dtd-actions">
    <button class="dtd-btn" (click)="cancel()">Cancelar</button>
    <button class="dtd-btn dtd-primary" (click)="accept()">Aceptar</button>
  </div>
</div>
